export const isBrowser = typeof document !== 'undefined';
// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (v) => typeof v === 'function';
export function isElement(element) {
    return element instanceof Element;
}
export function isHTMLElement(element) {
    return element instanceof HTMLElement;
}
export function isHTMLInputElement(element) {
    return element instanceof HTMLInputElement;
}
export function isElementDisabled(element) {
    const ariaDisabled = element.getAttribute('aria-disabled');
    const disabled = element.getAttribute('disabled');
    const dataDisabled = element.hasAttribute('data-disabled');
    if (ariaDisabled === 'true' || disabled !== null || dataDisabled) {
        return true;
    }
    return false;
}
export function isTouch(event) {
    return event.pointerType === 'touch';
}
export function isLeftClick(event) {
    return event.button === 0 && event.ctrlKey === false && event.metaKey === false;
}
export function isFocusVisible(element) {
    return element.matches(':focus-visible');
}
